<template>
  <div>
    <div class="inner" id="formanchor">
      <div class="grid">
        <div>
          <div class="heading" v-if="!isAService && !isSchoolsPage">Send us a message</div>
          <div class="heading" v-else-if="isAService">Get a free {{ page.name }} quote</div>
          <div class="heading" v-else-if="isSchoolsPage">Get a free quote</div>
          <form class="form" data-netlify="true" data-netlify-honeypot="bot-field" method="post" name="contact-form">
            <input name="form-name" type="hidden" value="contact-form" />
            <div class="row">
              <input class="input" name="name" placeholder="Name" required type="text" />
              <span class="bottom"></span>
              <span class="right"></span>
              <span class="top"></span>
              <span class="left"></span>
            </div>
            <div class="row">
              <input class="input" name="telephone" placeholder="Telephone" required type="text" />
              <span class="bottom"></span>
              <span class="right"></span>
              <span class="top"></span>
              <span class="left"></span>
            </div>
            <div class="row">
              <input class="input" name="email" placeholder="Email" type="email" />
              <span class="bottom"></span>
              <span class="right"></span>
              <span class="top"></span>
              <span class="left"></span>
            </div>
            <div class="row">
              <textarea class="input" name="message" placeholder="Message" required></textarea>
              <span class="bottom"></span>
              <span class="right"></span>
              <span class="top"></span>
              <span class="left"></span>
            </div>
            <button
              class="submit"
              @click="gtag('event', 'conversion', { send_to: 'AW-417591234/jM6QCMe1zfYBEMLfj8cB' })"
            >
              Submit
            </button>
          </form>
        </div>
        <div>
          <div class="heading">Get in touch</div>
          <div class="contact" v-if="settings && settings.telephone">
            <font-awesome-icon icon="phone" />

            <a :href="'tel:' + settings.telephone.replace(/ /g, '')">{{ settings.telephone }}</a>
          </div>
          <div class="contact" v-if="settings && settings.email">
            <font-awesome-icon icon="envelope" />

            <a :href="'mailto:' + settings.email">{{ settings.email }}</a>
          </div>
          <div class="contact" v-if="settings && settings.instagram">
            <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'instagram' }" />
            <a :href="settings.email" aria-label="Instagram" rel="noreferrer" target="_blank">@large_format_print_uk</a>
          </div>

          <div class="contact" v-if="settings && settings.address">
            <font-awesome-icon icon="map-pin" />
            <a href="https://goo.gl/maps/pW1CUNBterbDGNir5" v-html="settings.address.replace(/[\n\r]/g, '<br>')"></a>
          </div>
        </div>
      </div>
    </div>
    <div class="map-container" v-if="!isAService && !isSchoolsPage">
      <iframe
        allowfullscreen
        aria-hidden="false"
        class="map"
        frameborder="0"
        height="550"
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d9507.177669964336!2d-1.0236364693725593!3d53.43638400624665!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x75e791fe02106627!2sSPJ%20Marketing%20Ltd!5e0!3m2!1sen!2suk!4v1598017716534!5m2!1sen!2suk"
        style="border:0;"
        tabindex="0"
        width="100%"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex"

export default {
  computed: {
    ...mapState(["settings", "page"]),
    ...mapGetters(["isAService", "isSchoolsPage"])
  }
}
</script>

<style scoped>
.map-container {
  line-height: 0;
}
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 7rem 0;
  clear: both;
  font-size: 2rem;
}

.row {
  position: relative;
  width: 90rem;
  margin-bottom: 3rem;
  max-width: 60%;
}

.row .input {
  width: 100%;
  color: #272425;
  font-size: inherit;
  font-family: inherit;
  background-color: #f5f5f5;
  padding: 1rem 2rem;
  border: 1px solid transparent;
  transition: background-color 0.3s ease-in-out;
  font-size: 2.5rem;
  font-family: "Bebas Neue", cursive;
}

.row textarea.input {
  height: 30rem;
}

.row .input:focus {
  outline: none;
}

.row .input::placeholder {
  color: rgb(172, 172, 172);
}

.row span {
  position: absolute;
  background-color: #c1d62f;
  transition: transform 0.5s ease;
}

.bottom,
.top {
  height: 0.5rem;
  left: 0;
  right: 0;
  transform: scaleX(0);
}

.left,
.right {
  width: 0.5rem;
  top: 0;
  bottom: 0;
  transform: scaleY(0);
}

.bottom {
  bottom: 0;
  transform-origin: bottom right;
}

.row .input:focus ~ .bottom {
  transform-origin: bottom left;
  transform: scaleX(1);
}

.right {
  right: 0;
  transform-origin: top right;
}

.row .input:focus ~ .right {
  transform-origin: bottom right;
  transform: scaleY(1);
}

.top {
  top: 0;
  transform-origin: top left;
}

.row .input:focus ~ .top {
  transform-origin: top right;
  transform: scaleX(1);
}

.left {
  left: 0;
  transform-origin: bottom left;
}

.row .input:focus ~ .left {
  transform-origin: top left;
  transform: scaleY(1);
}

.submit {
  padding: 0.5rem 1.5rem;
  font-size: 2.5rem;
  border: 0;
  cursor: pointer;
  transition: all 0.3s;
  background: #c1d62f;
  border: 0.5rem solid #c1d62f;
  color: black;
  text-transform: uppercase;
  font-family: "Bebas Neue", cursive;
}

.submit:hover {
  background: #000;
  color: white;
  border: 0.5rem solid #c1d62f;
}

.contact {
  padding-bottom: 1rem;
  display: block;
  display: table;
  width: 100%;
}

.contact svg {
  width: 3rem;
  margin-right: 1rem;
  float: left;
  color: #c1d62f;
}

.contact a {
  float: left;
}

@media screen and (max-width: 950px) {
  .map {
    height: 450px;
  }
  .grid {
    grid-template-columns: 1fr;
    gap: 7rem;
  }
}

@media screen and (max-width: 700px) {
  .row {
    float: none;
    width: 100%;
    max-width: 100%;
  }
}
</style>
